import { Navigate, Outlet } from 'react-router-dom';

import { config } from '@/config/environment';

/**
 * The client monitoring pages, when `VITE_CLIENT_MONITORING_ENABLED` is on.
 *
 * Redirects home rather than rendering nothing when it is off: the way into
 * these pages is a link in an alert or digest email, and a blank screen reads
 * as broken.
 */
export function ClientMonitoringRoute() {
  if (!config.clientMonitoringEnabled) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}
